module.exports = __webpack_public_path__ + "img/ch.643ee0e7.png";